import './weapons.scss';

import { SettingsContext } from 'context/context';
import combat_icon from 'assets/icons/combat.svg';
import crosshair_icon from 'assets/icons/crosshair.svg';
import { useContext } from 'react';

function Weapons({ weapons, weaponsList, className='weapons', simplified=false }) {
  const { state } = useContext(SettingsContext);

  const formatWeaponName = (weapon) => {
    const hasIcon = weapon.name.includes('⚔') || weapon.name.includes('⌖');
    return hasIcon ? (weapon.name.slice(2)) : (weapon.name);
  }

  const displayWeaponType = (weapon) => {
    const isRange = weapon.name.includes('⌖');
    return (<img src={ isRange ? (crosshair_icon) : (combat_icon)} alt={ isRange ? 'Range Weapon' : 'Melee Weapon'} />);
  }

  const filterWeapons = (weaponsList) => {
    let weaponNames = Object.keys(weaponsList);
    let filteredWeapons = weaponNames.map((name) => weaponsList[name]);
    if (!state.displayEquipment) {
      filteredWeapons = weapons.filter((weapon) => !weapon.addon);
    }

    filteredWeapons = filteredWeapons.filter((weapon) => weapon.type === 'weapon');

    return filteredWeapons.map((weapon, index) => (
      <tr key={index}>
      <td className="icon">
        { displayWeaponType(weapon) }
      </td>
      <td className="name" dangerouslySetInnerHTML={{__html: `${formatWeaponName(weapon)}`}} />
      <td>{weapon.stats.A}</td>
      <td className="center">{weapon.stats['WS/BS']}</td>
      <td className="center">{weapon.stats.D}</td>
      { !simplified ? (<>
        <td className="small">{weapon.stats.SR}</td>
        <td className="small">{weapon.stats['!']}</td>
      </>) : null }
    </tr>
    ));
  }

  return (
    <div className={className}>
      <table>
        <thead>
          <tr>
            <th className="icons"></th>
            <th className="name">Name</th>
            <th>A</th>
            <th className="center">BS/WS</th>
            <th className="center">D</th>
            { !simplified ? (<>
              <th className="sr">SR</th>
              <th>!</th>
            </>) : null}
          </tr>
        </thead>
        <tbody>
          {
            filterWeapons(weaponsList)
          }
        </tbody>
      </table>
    </div>
  );
}

export default Weapons;
